import { render, staticRenderFns } from "./suppEdit.vue?vue&type=template&id=3524a378&scoped=true&"
import script from "./suppEdit.vue?vue&type=script&lang=js&"
export * from "./suppEdit.vue?vue&type=script&lang=js&"
import style0 from "./suppEdit.vue?vue&type=style&index=0&id=3524a378&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3524a378",
  null
  
)

export default component.exports